export * from './profile-language.graphql';
export * from './profile.graphql';
export * from './settings-admin-list.graphql';
export * from './settings-company-details-country-list.graphql';
export * from './settings-company-details.graphql';
export * from './settings-members-list.graphql';
export * from './settings-members-permissions.graphql';
export * from './settings-members-roles.graphql';
export * from './settings-user-details-to-manage-permission.graphql';
export * from './settings-submit-manage-members-permissions.graphql';
export * from './settings-user-validation.graphql';
export * from './co-browsing-company-list.graphql';
export * from './site-master-list.graphql';
export * from './service-master-list.graphql';
export * from './user-validation.graphql';
export * from './email-notifications.graphql';
